const useTabulusRegistry = () => {};

export { useTabulusRegistry };
useTabulusRegistry;
